import { FC, memo } from 'react'

import { EmailInput, FF, FormType, LicenseMultiSelect, SecuredInput, TextInput, Validators } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { ChoiceOption } from 'ui/types'

import { BioTrackFormPayload } from '../types'

import * as SC from './styles'

type Props = {
  form: FormType<BioTrackFormPayload>
  licensesToAssign: ChoiceOption[]
}

export const BioTrackForm: FC<Props> = memo((props) => {
  const { form, licensesToAssign } = props

  return (
    <>
      <SC.Title>BioTrackTHC Setup</SC.Title>
      <SC.Note>Enter credentials to connect your license</SC.Note>
      <FormRow>
        <Col>
          <form.Field
            name="username"
            validators={{
              onSubmit: ({ value }) => Validators.required.field(value)
            }}
            children={(field) => (
              <FF label="Email" field={field} required input={(inputProps) => <EmailInput {...inputProps} />} />
            )}
          />
        </Col>
        <Col>
          <form.Field
            name="password"
            validators={{
              onSubmit: ({ value }) => Validators.required.field(value)
            }}
            children={(field) => (
              <FF label="Password" field={field} required input={(inputProps) => <SecuredInput {...inputProps} />} />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <form.Field
            name="ubi"
            validators={{
              onSubmit: ({ value }) => Validators.required.field(value)
            }}
            children={(field) => (
              <FF label="UBI" field={field} required input={(inputProps) => <TextInput {...inputProps} />} />
            )}
          />
        </Col>
        <Col>
          <form.Field
            name="licenseIds"
            validators={{
              onSubmit: ({ value }) => Validators.required.array()(value)
            }}
            children={(field) => (
              <FF
                label="License(s)"
                field={field}
                required
                input={(inputProps) => <LicenseMultiSelect data={licensesToAssign} {...inputProps} />}
              />
            )}
          />
        </Col>
      </FormRow>
    </>
  )
})
